export const designation_details = [
  {
    Designation: "Accountant",
    Department: "Finance",
    NoOfEmployees: "10",
    Status: "Active",
  },
  {
    Designation: "App Developer",
    Department: "Application Development",
    NoOfEmployees: "15",
    Status: "Active",
  },
  {
    Designation: "Technician",
    Department: "IT Management",
    NoOfEmployees: "08",
    Status: "Active",
  },
  {
    Designation: "Web Developer",
    Department: "Web Development",
    NoOfEmployees: "10",
    Status: "Active",
  },
  {
    Designation: "Sales Executive Officer",
    Department: "Sales",
    NoOfEmployees: "10",
    Status: "Active",
  },
  {
    Designation: "Designer",
    Department: "UI / UX",
    NoOfEmployees: "15",
    Status: "Active",
  },
  {
    Designation: "Account Manager",
    Department: "Account Management",
    NoOfEmployees: "08",
    Status: "Active",
  },
  {
    Designation: "SEO Analyst",
    Department: "Marketing",
    NoOfEmployees: "10",
    Status: "Inactive",
  },
  {
    Designation: "Admin",
    Department: "Administration",
    NoOfEmployees: "05",
    Status: "Active",
  },
  {
    Designation: "Business Analyst",
    Department: "Business Development",
    NoOfEmployees: "07",
    Status: "Active",
  },
];
